import Text from 'components/priority/Text/Text'
import * as S from './Support.styled'
import { useTranslation } from 'react-i18next'

export const SupportHeader = () => {
  const { t } = useTranslation()
  return (
    <S.HeaderContainer full padding="28px 40px" margin="0 0 32px">
      <Text size="32px" weight="600">
        {t('package.supportButton')}
      </Text>
    </S.HeaderContainer>
  )
}

export default SupportHeader
